import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import ButtonScaleView, {
  ButtonScaleViewOpts,
} from 'src/lib/ui/components/ButtonScaleView';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import uiConfig from 'src/lib/ui/config';
import { parseAmount } from 'src/lib/utils';
import { Currency } from 'src/replicant/data/Gachas.schema';
import { assertNever } from 'src/replicant/utils';

const ui = uiConfig.buruburu.care.confirmation;

export type GachaItemOpts = ButtonScaleViewOpts & {
  title: string;
  oldPrice?: number;
  newPrice: number;
  currency: Currency;
  single: boolean;
};

export class GachaItem extends ButtonScaleView {
  constructor({
    title,
    oldPrice,
    newPrice,
    currency,
    single,
    ...opts
  }: GachaItemOpts) {
    super({
      height: 150,
      width: 491,
      x: 20,
      y: 150,
      pressedOffsetY: 5,
      ...opts,
    });

    const background = this.addSubview(
      new ImageScaleView({
        ...opts,
        ...ui.careItemPanel,
        x: 0,
        y: 0,
        height: 150,
      }),
    );

    // icon
    background.addSubview(
      new ImageScaleView({
        scaleMethod: 'contain',
        x: 15,
        y: 13,
        width: 140,
        height: 120,
        image: single
          ? 'assets/ui/gacha/icons/gacha_icon.png'
          : 'assets/ui/gacha/icons/gacha_x10_icon.png',
      }),
    );

    // title
    background.addSubview(
      new LangBitmapFontTextView({
        font: 'Body',
        color: '#9A7171',
        y: 10,
        size: 30,
        x: 190,
        height: 39,
        width: 283,
        localeText: () => title,
        verticalAlign: 'bottom',
      }),
    );

    // old price
    if (oldPrice) {
      background.addSubview(
        this.createCurrencyView(190, 74, oldPrice, currency, true),
      );
    }

    // new price
    background.addSubview(this.createCurrencyView(335, 70, newPrice, currency));
  }

  private createCurrencyView(
    x: number,
    y: number,
    price: number,
    currency: Currency,
    isOld = false,
  ) {
    const superview = new View({
      width: 95 + 47,
      height: 56,
      x,
      y,
      scale: isOld ? 0.8 : 0.9,
    });

    new LangBitmapFontTextView({
      superview,
      size: 35,
      width: 95,
      height: 56,
      align: 'center',
      verticalAlign: 'center',
      font: 'Body',
      color: isOld ? '#9A7171' : '#0EAF00',
      localeText: () => parseAmount(price),
    });

    if (isOld) {
      new ImageScaleView({
        superview,
        x: 53,
        y: superview.style.height / 2,
        width: 105,
        height: 5,
        backgroundColor: '#9A7171',
        centerOnOrigin: true,
      });

      new ImageScaleView({
        superview,
        scaleMethod: 'contain',
        x: 173,
        y: superview.style.height / 2,
        width: 18,
        height: 56,
        image: 'assets/ui/shared/icons/arrow_right.png',
        centerOnOrigin: true,
      });
    }

    switch (currency) {
      case 'gems':
        new ImageScaleView({
          superview,
          image: 'assets/ui/hud/icons/hud_gem.png',
          width: 66,
          height: 56,
          x: 95,
          r: 0.1,
        });
        break;
      case 'bronze_ticket':
      case 'silver_ticket':
        new ImageScaleView({
          superview,
          image: 'assets/ui/gacha/icons/ticket.png',
          width: 55,
          height: 46,
          x: 95,
        });
        break;
      default:
        assertNever(currency);
    }

    return superview;
  }
}
